export default __webpack_public_path__ + "static/snorkel_svg-54dafac6e1d5a733ba0e5d39669ccd1f.svg";